export default "__VITE_ASSET__xM9qIgAH__"